import React from 'react';
import FeaturedCuesheet from 'main/components/show/cuesheet.featured/cuesheet.jsx';
import FeaturedEditor from 'main/components/show/cuesheet.featured/featuredEditor.jsx';
import CuesheetHeader from 'main/components/show/cuesheet/header.jsx';
import CuesheetFooter from 'main/components/show/cuesheet/footer.jsx';
import EventViewActions from 'flux/actions/EventViewActions';
import TeamViewActions from 'flux/actions/TeamViewActions';
import EventShowListActions from 'flux/actions/EventShowListActions';
import Search from 'main/components/search/search.jsx';
import ActivityAuditList from 'main/components/activityAudit/list.jsx';
import AlertBarAwareContainer from 'main/components/show/cuesheet/alertBarAwareContainer';

/* eslint-disable react/prop-types */

const FeaturedCuesheetPage = React.createClass({
  displayName: 'FeaturedCuesheetPage',

  render() {
    return (
      <AlertBarAwareContainer className="show-featured-wrapper">
        <CuesheetHeader disableLightTheme />
        <div className="show-featured-body-wrapper">
          <div className="show-featured-wrapper-table">
            <FeaturedCuesheet {...this.props.params} />
          </div>
          <div className="show-featured-wrapper-editor">
            <FeaturedEditor {...this.props.params} />
          </div>
        </div>
        <Search />
        <ActivityAuditList />
        <CuesheetFooter displayTrackingElements disableLightTheme />
      </AlertBarAwareContainer>
    );
  },
  componentDidMount() {
    let { teamId, eventId } = this.context.router.state.params;

    TeamViewActions.populate(teamId);
    EventViewActions.populate(teamId, eventId);
    EventShowListActions.populate(teamId, eventId);
  },
});

FeaturedCuesheetPage.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export default FeaturedCuesheetPage;
